import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
`

export const WrapperEmployeeData = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`

export const Text = styled.text`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.darkGrey};
`
